import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-550e7b7e")

_pushScopeId("data-v-550e7b7e")
const _hoisted_1 = { class: "header df-middle f-sm" }
const _hoisted_2 = { class: "flex-1 ml-12 f-sm" }
const _hoisted_3 = { class: "mb-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_Time = _resolveComponent("Time")
  const _component_t = _resolveComponent("t")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Pic, {
        src: _ctx.postData.avatarPic,
        fallback: "/img/user/Avatar@2x.png",
        width: "32",
        height: "32",
        style: {"border-radius":"50%"}
      }, null, 8, ["src"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("p", _hoisted_3, _toDisplayString(_ctx.postData.nickName), 1),
        _createVNode(_component_Time, {
          time: _ctx.postData.createTime,
          format: "MM-dd-yyyy HH:mm:ss",
          class: "c-tip"
        }, null, 8, ["time"])
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode("div", {
      class: ["mt-16 program", {content: !_ctx.detail}],
      innerHTML: _ctx.useTranslate?_ctx.formatText:_ctx.postData.content,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
    }, null, 10, ["innerHTML"]),
    (_ctx.useTranslate)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          onClick: _ctx.translate,
          progress: _ctx.progress,
          class: ["round f-sm mt-24", {primary: _ctx.isOrigin}],
          sm: "",
          style: {"height":"22px","line-height":"18px"}
        }, {
          default: _withId(() => [
            _createVNode(_component_t, {
              path: _ctx.isOrigin ? 'post_10' : 'post_11'
            }, null, 8, ["path"])
          ]),
          _: 1
        }, 8, ["onClick", "progress", "class"]))
      : _createCommentVNode("", true)
  ], 64))
})